import get from 'lodash/get'
import omit from 'lodash/omit'
import reduce from 'lodash/reduce'

import { parseValidationErrors } from './parseSubmissionErrors'

/**
 * @example
 *   } catch (badResponse) {
 *     const errors = parseReduxFormErrorsFromResponse(badResponse)
 *     showError({
 *       title: errors._error,
 *       content: errors.toString(),
 *     })
 *     yield put(stopSubmit(FORM_NAME, errors))
 * @param response
 */
export const parseReduxFormErrorsFromResponse = response => {
  const message = get(response, ['data', 'message'])
  let errors = {}
  if (response.data.errors) {
    errors = parseValidationErrors(response.data.errors)
    if (message) {
      errors._error = message
    }
    errors.toString = () =>
      reduce(
        omit(errors, ['_error', 'toString']),
        (res, el, key) => (res === '' ? `${key} ${el}` : `; ${key} ${el}`),
        ''
      )
  } else {
    if (message) {
      errors._error = message
      errors.toString = () => message
    }
  }
  return errors
}
